<template>
    <v-container class="ma-0 pa-0 steps_container" fill-height>
        <v-row dense class="ma-0 pa-0 px-7">
            <v-col cols="12" align-self="start" class="steps_title_descript">
                <p class="steps_count">1/8</p>
                <span class="steps_bolder_words">혈압</span>은<br />
                평소에 어떤 편 이신가요?
            </v-col>
        </v-row>
        <v-row dense class="ma-0 pa-0 py-16">
            <v-col cols="12" align-self="start" align="center" class="avatar" v-if="selected !== 'direct'">
                <img
                    :src="getAvatarImage"
                    class="avatar-img"
                    alt="아바타"
                >
            </v-col>
            <v-col cols="12" align-self="center" align="center" class="pa-0 ma-0">
                <button
                    class="blood mx-2"
                    tabindex="1"
                    role="button"
                    :class="selected === 'low' ? 'selected' : ''"
                    @click="selectBloodPressure('low')"
                    @keydown.enter="selectBloodPressure('low')"
                >
                    <img
                        :src="getBPImage('low')"
                        class="blood-img"
                        alt="저혈압"
                    >
                    <br/>
                    저혈압
                </button>
                <button
                    class="blood mx-2"
                    tabindex="2"
                    role="button"
                    :class="selected === 'normal' ? 'selected' : ''"
                    @click="selectBloodPressure('normal')"
                    @keydown.enter="selectBloodPressure('normal')"
                >
                    <img
                        :src="getBPImage('normal')"
                        class="blood-img"
                        alt="정상혈압"
                    >
                    <br/>
                    정상
                </button>
                <button
                    class="blood mx-2"
                    tabindex="3"
                    role="button"
                    :class="selected === 'high' ? 'selected' : ''"
                    @click="selectBloodPressure('high')"
                    @keydown.enter="selectBloodPressure('high')"
                >
                    <img
                        :src="getBPImage('high')"
                        class="blood-img"
                        alt="고혈압"
                    >
                    <br/>
                    고혈압
                </button>
                <button
                    class="blood mx-2"
                    tabindex="4"
                    role="button"
                    :class="selected === 'direct' ? 'selected' : ''"
                    @click="selectBloodPressure('direct')"
                    @keydown.enter="selectBloodPressure('direct')"
                >
                    <img
                        :src="getBPImage('direct')"
                        class="blood-img"
                        alt="직접입력"
                    >
                    <br/>
                    직접입력
                </button>
            </v-col>
        </v-row>
        <v-row dense class="ma-0 pa-0 px-7">
            <v-col cols="12" class="input-wrapper" v-if="selected === 'direct'">
                <label>
                    <input
                        v-model="bpLow"
                        ref="bpLow"
                        type="number"
                        maxlength="5"
                        tabindex="5"
                        class="direct-input"
                        placeholder="최저혈압"
                    />
                    mmHg ~
                </label>
                <label>
                    <input
                        v-model="bpHigh"
                        type="number"
                        maxlength="6"
                        tabindex="6"
                        class="direct-input"
                        placeholder="최고혈압"
                    />
                    mmHg
                </label>
            </v-col>
            <v-col cols="12" class="blood-desc" v-if="selected === 'direct'">
                최저혈압 30~250 / 최고혈압 60~400<br/>
                <span v-if="hintMessage && disabled">
                    범위 안의 수치를 다시 확인해주세요.
                </span>
            </v-col>
        </v-row>

        <v-container class="ma-0 pa-0 pt-10 steps_container footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" align-self="end" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" align-self="end" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
    </v-container>
</template>

<script>
import utils from "@/utils/utils";
import { alert } from '@/mixins'
import { mapActions, mapGetters } from "vuex";

export default {
	mixins: [utils, alert],
	data: () => ({
		enableButton: true,
		selected : 'normal',
		bpLow : 75,
		bpHigh : 115,
		bpClass : {
			low: [ 55, 85 ],
			normal: [ 75, 115 ],	/* 120 / 80 이하 */
			high: [ 110, 160 ]		/* 1차 140/90 이상, 2차 160/100 이상 */
		}
	}),
    computed: {
        ...mapGetters("survey", {
            checkUp: "checkUp",
            checkupTemp: "checkupTemp"
        }),
        getAvatarImage() {
            switch(this.selected) {
                case 'low': return require('@/assets/images/avatar-pressure-low.png')
                case 'normal': return require('@/assets/images/avatar-pressure-normal.png')
                case 'high': return require('@/assets/images/avatar-pressure-high.png')
                case 'direct': return ''
                default: return require('@/assets/images/avatar-pressure-normal.png')
            }
        },
        disabled () {
            let { bpHigh, bpLow } = this
            bpHigh = Number(bpHigh)
            bpLow = Number(bpLow)

            if (bpLow < 30 || bpLow > 250) {
                return true
            } else if (bpHigh < 60 || bpHigh > 400) {
                return true
            } else if (bpHigh < bpLow) {
                return true
            }

            return false
        },
        hintMessage () {
            const { bpHigh, bpLow } = this
            return bpHigh !== null && bpLow !== null
        }
    },
    watch: {
        selected (value) {
            if (value === 'direct') {
                this.initializeDirect()
            }
        }
    },
	methods: {
        ...mapActions('survey', [
			'setCheckupTemp',
			'setStep'
        ]),
        async initializeDirect () {
            await this.$nextTick()
            this.$refs.bpLow.focus()
            this.bpLow = null
            this.bpHigh = null
        },
		previous() {
			this.setStep(3)
			this.$router.push("/checkup/step1");
		},
		next() {
            const { bpLow, bpHigh } = this

			const params = {
				step: 4,
				bpLow: bpLow,
				bpHigh: bpHigh,
				bpSelected: this.selected,
			};

			this.setCheckupTemp(params);
			this.setStep(5)
			this.$router.push("/checkup/step5");
		},
		selectBloodPressure(selected) {
			this.selected = selected
			switch(this.selected) {
				case 'low':
					this.bpLow = this.bpClass.low[0]
					this.bpHigh = this.bpClass.low[1]
					break;
				case 'normal':
					this.bpLow = this.bpClass.normal[0]
					this.bpHigh = this.bpClass.normal[1]
					break;
				case 'high':
					this.bpLow = this.bpClass.high[0]
					this.bpHigh = this.bpClass.high[1]
					break;
			}
		},
		getBPImage(value) {
			if(this.selected === value) {
				switch(value) {
					case 'low': return require('@/assets/images/ico-pressure-low-p.png')
					case 'normal': return require('@/assets/images/ico-pressure-normal-p.png')
					case 'high': return require('@/assets/images/ico-pressure-high-p.png')
					case 'direct': return require('@/assets/images/ico-pressure-edit-p.png')
				}
			}
			else {
				switch(value) {
					case 'low': return require('@/assets/images/ico-pressure-low-n.png')
					case 'normal': return require('@/assets/images/ico-pressure-normal-n.png')
					case 'high': return require('@/assets/images/ico-pressure-high-n.png')
					case 'direct': return require('@/assets/images/ico-pressure-edit-n.png')
				}
			}
		},
		restoreData() {
			if(this.checkupTemp.bpSelected) {
				this.selected = this.checkupTemp.bpSelected
			}
			else if(this.checkUp.bpLow > 0 || this.checkUp.bpHigh) {
				this.selected = 'direct'
				this.bpLow = this.checkUp.bpLow
				this.bpHigh = this.checkUp.bpHigh
			}
		}
    },
	mounted() {
        window.scrollTo(0, 0)
		this.setStep(4)
		this.restoreData()
	}
};
</script>

<style scoped lang="scss">
	.avatar {
		text-align: center;
		margin-bottom: 2vh;
    }
    .avatar-img {
        width: 94px;
    }

	.blood {
		display: inline-block;
    }
    .blood.selected {
        color: #e3153f;
        font-weight: bold;
    }
	.blood-img {
		height: 60px;
    }
    .blood-desc {
        color: #c4c4c4;
        font-size: 1.0em;
        padding: 20px;
        text-align: center;

        span {
            color: #e3153f;
            font-weight: 600;
        }
    }
	.direct-input {
		font-weight: bold;
		width: 40px;
		text-align: right;
        color: #e3153f;
        font-size: 0.9em;
	}

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }
</style>
